<app-breadcrumb  *ngIf="!post" [master]="'ASF360'" [parentName]="'Posty'" [name]="'Dodaj'"></app-breadcrumb>
<div class="post-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button  [class.spinner]="postAdd" [disabled]="postAdd"   (click)="sendForm(true)" mat-stroked-button color="accent"><mat-icon>publish</mat-icon> <span> Opublikuj</span></button>
    <button  [class.spinner]="postAdd" [disabled]="postAdd"   (click)="sendForm(false)" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz jako szkic</span></button>
    <button  [class.spinner]="postAdd" [disabled]="postAdd"   (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="60" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row">
            <h3> Treść postu krótka</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa postu</mat-label>

                <input [required]="true"
                       [formControl]="postNameControl"
                       appCapitalizeFirst matInput placeholder="Nazwa postu"  >
                <mat-error *ngIf="postForm.get('postName').hasError('required')">To pole jest wymagane</mat-error>


              </mat-form-field>
            </div>

          </div>

          <div fxLayout="column" fxLayoutGap="15px">
<!--              <textarea [required]="true"-->
<!--                        [formControl]="shortContentControl"-->
<!--                style="min-height: 150px"-->
<!--                matInput-->
<!--              ></textarea>-->
            <div>
              <div>
                <span>Znaki: {{ shortContentControl.value?.length || 0 }}/500</span>
              </div>
              <div *ngIf="shortContentControl.hasError('maxlength')">
                <span style="color: red;">Przekroczono limit znaków!</span>
              </div>
            </div>
            <angular-editor fxFlex="100" [config]="editorConfig" [formControl]="shortContentControl" [required]="false" (paste)="onPaste($event, true)" ></angular-editor>

          </div>
          <div fxLayout="row"  fxLayoutAlign="center">

            <app-file-drag-and-drop fxFlex="100" [maxSize]="1050000" [multiple]="false"  acceptMime="*/*"  [fileControl]="fileShortControl"></app-file-drag-and-drop>
          </div>
<!--          <div *ngIf="postObject.attachments" fxLayoutAlign="space-between center" fxFlex="100">-->
<!--            <img class=" avatar-360" src="/rest/crm/asf360/file/{{formGroup.get('postDetailFileLocation').value}}/image/{{formGroup.get('postDetailFilename').value}}" alt="Zdjęcie"/>-->
<!--          </div>-->

          <div *ngIf="fileShortControl.value.length === 0 && postObject" fxLayout="row"  fxLayoutAlign="center" fxLayoutGap="15px" >
            <div *ngFor="let attachment of postObject?.attachments">
              <img
                *ngIf='attachment.type.key==="short"'
                src="{{src.production}}/filePublic/{{attachment.fileLocation}}"
              />
            </div>
          </div>

          <div fxLayout="row">
            <h3> CTA</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">

            <mat-slide-toggle [formControl]="competitionCtaControl" >Konkursowe CTA</mat-slide-toggle>


          </div>
          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="50">
              <mat-form-field fxFlex="100">
                <mat-label>Nagłówek CTA</mat-label>

                <input [formControl]="ctaHeadlineControl" appCapitalizeFirst matInput placeholder="Nagłówek CTA" >

              </mat-form-field>
            </div>


            <div fxFlex="50">
              <mat-form-field fxFlex="100">
                <mat-label>Tekst CTA</mat-label>
                <input [formControl]="ctaTextControl" matInput placeholder="Tekst CTA" >

              </mat-form-field>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50" *ngIf="!competitionCtaControl.value">
              <mat-form-field fxFlex="100">
                <mat-label>Link CTA</mat-label>
                <input [formControl]="ctaLinkControl"  [required]="cta"  appCapitalizeFirst matInput placeholder="http://"  >
              </mat-form-field>
            </div>

            <div fxFlex="50" *ngIf="competitionCtaControl.value">
              <mat-form-field fxFlex="100">
                <mat-label>Przycisk CTA po kliknięciu </mat-label>
                <input [formControl]="ctaLinkControl"  [required]="cta"  appCapitalizeFirst matInput placeholder=""  >
              </mat-form-field>
            </div>

            <div fxFlex="50">
              <mat-form-field fxFlex="100">
                <mat-label>Przycisk CTA</mat-label>
                <input [formControl]="ctaButtonControl"  [required]="cta" appCapitalizeFirst matInput placeholder="Przycisk CTA" >
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="competitionCtaControl.value">
            <div fxFlex="100" fxLayoutGap="15px">
              <div fxFlex>
                <app-datepicker
                  label="Aktywny do"
                  placeholder="2000-01-01"
                  [required]="false"
                  [formControl]="ctaEndDateControl"
                ></app-datepicker>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="ctaEndDateControl.value">
            <div fxFlex="100" fxLayoutGap="15px">
              <div fxFlex>
                <mat-form-field fxFlex="100">
                  <mat-label>Nagłówek CTA po wygaśnięciu</mat-label>
                  <input
                    [formControl]="ctaExpiredTextControl"
                    [required]="ctaEndDateControl.value"
                    appCapitalizeFirst
                    matInput
                    placeholder="Nagłówek CTA po wygaśnięciu">
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card>


      <mat-card>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <h3>Treść postu długa</h3>
          </div>
        </div>


        <div fxLayout="column" fxFlex.lt-md="100" fxLayoutGap="15px" cdkDropList [cdkDropListData]="postDetails" (cdkDropListDropped)="drop($event)">
          <ng-container *ngFor="let formGroup of postDetails; let i = index">
            <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">
              <mat-card  *ngIf="formGroup.get('postDetailType').value === 'TEXT'" fxFlex="100" fxLayoutGap="15px">
                <div   fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div cdkDrag  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Pole tekstowe</h3>

                      <button (click)="removePostDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div >
                  </div>
                  <div  fxLayout="row"  fxFlex="90">
                    <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="postDetailText" [required]="true" (paste)="onPaste($event, false)"></angular-editor>
                  </div>
                </div >
              </mat-card>

              <mat-card cdkDrag *ngIf="formGroup.get('postDetailType').value === 'ATTACHMENT' || formGroup.get('postDetailType').value === 'GRAPHICS'" fxFlex="100" fxLayoutGap="15px">
                <div  fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div *ngIf="formGroup.get('postDetailType').value === 'ATTACHMENT'"  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Załacznik</h3>

                      <button (click)="removePostDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <div *ngIf="formGroup.get('postDetailType').value === 'GRAPHICS'"  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Grafika</h3>

                      <button (click)="removePostDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div  fxLayout="row"  fxFlex="90">
                    <app-file-drag-and-drop fxFlex="100" [maxSize]="maxSize" [multiple]="false" [generateOutput]="true" acceptMime="*/*" (fileSelected)="onFileChange($event, i)"></app-file-drag-and-drop>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px" *ngIf="formGroup.get('postDetailType').value === 'GRAPHICS'">
                    <div fxFlex="100">
                      <mat-form-field fxFlex="100">
                        <mat-label>Link </mat-label>
                        <input formControlName="postDetailCtaLink" matInput placeholder="http://" [required]="false">
                      </mat-form-field>
                    </div>
                  </div>
                  <div *ngIf="formGroup.get('postDetailType').value === 'ATTACHMENT' && !formGroup.get('edit').value" fxLayoutAlign="space-between center" fxFlex="100">
                      <button
                        (click)="downloadAttachmentFile(formGroup.get('postDetailFileLocation').value,
                        formGroup.get('postDetailFilename').value)"
                        mat-stroked-button
                      >
                        <mat-icon>download</mat-icon>
                        <span> {{ formGroup.get('postDetailFilename').value }}</span></button>
                  </div>
                  <div *ngIf="formGroup.get('postDetailType').value === 'GRAPHICS'  && !formGroup.get('edit').value && formGroup.get('postDetailFileLocation').value" fxLayoutAlign="space-between center" fxFlex="100">
                    <img class=" avatar-360" src="/rest/crm/asf360/file/{{formGroup.get('postDetailFileLocation').value}}/image/{{formGroup.get('postDetailFilename').value}}" alt="Zdjęcie"/>
                  </div>
                </div>
              </mat-card>

              <mat-card cdkDrag *ngIf="formGroup.get('postDetailType').value === 'CTA'" fxFlex="100" fxLayoutGap="15px">
                <div  fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. CTA</h3>

                      <button (click)="removePostDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div  fxLayout="row"  fxFlex="100">
                    <div  fxLayout="column"   fxFlex="100" >
                      <div fxLayout="row" fxLayoutGap="15px">
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Nagłówek CTA</mat-label>
                            <input formControlName="postDetailCtaHeadline" matInput placeholder="Nagłówek CTA">
                          </mat-form-field>
                        </div>
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Tekst CTA</mat-label>
                            <input formControlName="postDetailCtaText" matInput placeholder="Tekst CTA">
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutGap="15px">
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Link CTA</mat-label>
                            <input formControlName="postDetailCtaLink" matInput placeholder="http://" [required]="true">
                          </mat-form-field>
                        </div>
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Przycisk CTA</mat-label>
                            <input formControlName="postDetailCtaButton" matInput placeholder="Przycisk CTA" [required]="true">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div >
              </mat-card>

              <mat-card  *ngIf="formGroup.get('postDetailType').value === 'TABLE'" fxFlex="100" fxLayoutGap="15px">
                <div  fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div cdkDrag fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Tabela</h3>
                      <mat-form-field fxFlex="30">
                        <mat-label>Ilość Kolumn</mat-label>
                        <input
                          type="number"
                          formControlName="postTableColumn"
                          matInput
                          [required]="true"
                          min="2"
                          max="3">
                      </mat-form-field>
                      <button (click)="removePostDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div  fxLayout="row"  fxFlex="100">
                    <div  fxLayout="column"  fxFlex="{{formGroup.get('postTableColumn').value === 3 ? 33: 50 }}">
                      <div  fxLayout="row"  fxFlex="90">
                        <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="postDetailText" [required]="true" (paste)="onPaste($event, false)"></angular-editor>
                      </div>


                    </div>
                    <div  fxLayout="column"  fxFlex="{{formGroup.get('postTableColumn').value === 3 ? 33: 50 }}">
                      <div  fxLayout="row"  fxFlex="90">
                        <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="postDetailTextSecond" [required]="true" (paste)="onPaste($event, false)"></angular-editor>
                      </div>


                    </div>
                    <div *ngIf="formGroup.get('postTableColumn').value === 3 "  fxLayout="column"  fxFlex="33">
                      <div  fxLayout="row"  fxFlex="90">
                        <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="postDetailTextThird" [required]="true" (paste)="onPaste($event, false)"></angular-editor>
                      </div>


                    </div>

                  </div>
                </div >
              </mat-card>

              <mat-card  *ngIf="formGroup.get('postDetailType').value === 'MOVIE'" fxFlex="100" fxLayoutGap="15px">
                <div   fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div cdkDrag  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Film</h3>

                      <button (click)="removePostDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div >
                  </div>
                  <div  fxLayout="row"  fxFlex="90">
                    <mat-form-field fxFlex="100">
                      <mat-label>Link </mat-label>
                      <input formControlName="postDetailMovieLink" matInput placeholder="http://" [required]="true">
                    </mat-form-field>
                  </div>
                </div >
              </mat-card>

            </div>
            <br>
          </ng-container>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
          <div fxFlex="30">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPostDetails('TEXT')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Pole tekstowe</span>
            </button>
          </div>
          <div fxFlex="30">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPostDetails('ATTACHMENT')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Załącznik</span>
            </button>
          </div>
          <div fxFlex="30">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPostDetails('GRAPHICS')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Grafika</span>
            </button>
          </div>

        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
          <div fxFlex="30">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPostDetails('CTA')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>CTA</span>
            </button>
          </div>
          <div fxFlex="30">
            <button fxFlex="100" fxLayoutGap="15px"  (click)="addPostDetails('TABLE')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Tabela</span>
            </button>
          </div>
          <div fxFlex="30">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPostDetails('MOVIE')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Film</span>
            </button>
          </div>
        </div>
      </mat-card>



    </div>

    <div fxLayout="column" fxFlex="40"  fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row">
            <h3>Szczegóły postu</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <app-dict-tag
                [required]="true"
                [multiple]="false"
                [formControl]="publishingDepartmentControl"
                [tagType]="POST_TAG_TYPE_DEPARTMENT_TYPE"
              ></app-dict-tag>

            </div>

          </div>


          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <app-dict-tag
                [required]="true"
                [multiple]="false"
                [formControl]="typeControl"
                [tagType]="POST_TAG_TYPE_POST_TYPE"
              ></app-dict-tag>

            </div>

          </div>



          <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100">
                <app-dict-tag
                  [required]="false"
                  [multiple]="true"
                  [formControl]="tagsRemainingControl"
                  [tagType]="POST_TAG_TYPE_REMAINING"
                ></app-dict-tag>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100">
                <app-dict-tag
                  [required]="false"
                  [multiple]="true"
                  [formControl]="tagsInsuranceControl"
                  [tagType]="POST_TAG_TYPE_INSURANCE_COMPANY"
                ></app-dict-tag>
              </div>

            </div>
          </mat-card>

        <mat-card>
          <div fxLayout="row">
            <h3> Załączniki</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <app-file-drag-and-drop fxFlex="100" [multiple]="true" acceptMime="*/*"  [fileControl]="fileAttachmentControl"></app-file-drag-and-drop>
            </div>

          </div>

          <mat-card *ngIf="postObject && haveAttachmentAttachment">



                <div fxLayout="row" fxLayoutGap="15px" >
                  <div fxFlex="100" fxLayout="row">
                    <app-detail header="Załączniki">
                      <mat-chip-list>
                        <ng-container *ngFor="let attachment of postObject.attachments">
                          <mat-chip selected  *ngIf='attachment.type.key==="attachment"'>
                            {{attachment.fileName}}

                            <button matChipRemove
                                    (click)="downloadAttachment(attachment)">
                              <mat-icon>download</mat-icon>
                            </button>


<!--                            <button mat-icon-button color="warn"-->
<!--                                    (click)="deleteAttachment(attachment)">-->
<!--                              <mat-icon>cancel</mat-icon>-->
<!--                            </button>-->

                          </mat-chip>
                        </ng-container>
                      </mat-chip-list>
                    </app-detail>
                  </div>
                </div>


          </mat-card>
        </mat-card>

      <mat-card>
        <div fxLayout="row">
          <h3> Data Publikacji</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" fxLayoutGap="15px">
            <div fxFlex>
              <app-datepicker
                label="Data publikacji"
                placeholder="2000-01-01"
                [required]="true"
                [formControl]="startAtControl"
              ></app-datepicker>
            </div>
            <div fxFlex="175px">
              <div>
                <ngx-timepicker-field [format]="24" [defaultTime]="'12:00'" [formControl]="startsAtTimeControl"></ngx-timepicker-field>
              </div>
            </div>

          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" fxLayoutGap="15">
            <div fxFlex>
              <app-datepicker
                label="Data wygaśnięcia"
                placeholder="2000-01-01 "
                [required]="false"
                [formControl]="endAtControl"
              ></app-datepicker>
            </div>
            <div fxFlex="175px">
              <div>
                <ngx-timepicker-field [format]="24" [defaultTime]="'23:59'" [formControl]="endsAtTimeControl"></ngx-timepicker-field>
              </div>
            </div>

          </div>


        </div>
      </mat-card>
      <mat-card  fxLayout="column" *ngIf="publishingDepartmentControl.value">
        <div fxLayout="row">
          <h3>
            Użytkownicy
          </h3>
        </div>

        <div fxLayout="row">
          <h4>Nagłówek: {{ header }}</h4>

        </div>

        <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of userFormArray; index as i">
          <div fxLayout="row" fxLayoutGap="15px"  fxFlex="100" [formGroup]="formGroup">
            <div fxFlex="5"  fxLayoutGap="15px">
              <div class="list-remove-button">
                {{i+1}}.
              </div>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Imie i nazwisko</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Imie i nazwisko" formControlName="usersName" [required]="true">
                <mat-error *ngIf="formGroup.get('usersName').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Stanowisko</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Stanowisko" formControlName="usersPosition" [required]="false">
                <mat-error *ngIf="formGroup.get('usersPosition').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px"  fxFlex="100"   [formGroup]="formGroup">
            <div fxFlex="5"  fxLayoutGap="15px">
              <div class="list-remove-button">
                <button (click)="removeUsers(i)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Numer telefonu</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Numer telefonu" formControlName="usersPhone" [required]="true">
                <mat-error *ngIf="formGroup.get('usersPhone').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Email</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Email" formControlName="usersEmail" [required]="true">
                <mat-error *ngIf="formGroup.get('usersEmail').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
              </span>
          <button (click)="addUsers(true)" mat-stroked-button color="primary">
            <mat-icon>add_box</mat-icon> <span> Dodaj</span>
          </button>
        </div>
      </mat-card>


      <mat-card>
        <div fxLayout="row">
          <h3>Uprawnienia</h3>
        </div>
        <div fxLayout="column"  fxLayoutGap="15px">
        <mat-card>

          <div fxLayout="row">
            <h4 class="structure-title">Grupy uprawnień</h4>
          </div>
          <div fxLayout="row">
            <p class="structure-description">Post będzie udostępniony tylko dla wskazanej grupy użytkowników.</p>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div  fxFlex="100">
              <app-dict-permission-tags
                [label]="'Grupy uprawnień'"
                [required]="false"
                [multiple]="true"
                [formControl]="permissionTagControl"
              ></app-dict-permission-tags>
            </div>
          </div>
            </mat-card>

          <mat-card >

            <div fxLayout="row">
              <h4 class="structure-title">Struktura</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Post będzie udostępniony dla użytkowników wskazanych struktur.</p>
            </div>


          <div fxLayout="row" fxLayoutGap="15px">
            <div  fxFlex="50">
              <mat-slide-toggle [formControl]="permissionAsfPremiumControl" >ASF Premium</mat-slide-toggle>
            </div>
            <div  fxFlex="50">
              <mat-slide-toggle  [formControl]="permissionMultisferaControl" >Multisfera</mat-slide-toggle>
            </div>

          </div>
          <div fxLayout="row" fxLayoutGap="15px">

            <div  fxFlex="50">
              <mat-slide-toggle  [formControl]="permissionAsfControl" >ASF</mat-slide-toggle>
            </div>
            <div  fxFlex="50">
              <mat-slide-toggle  [formControl]="permissionMultiAgencyProfitControl" >Multiagencja Profitowi</mat-slide-toggle>
            </div>

          </div>


          <div fxLayout="row" fxLayoutGap="15px">
            <div  fxFlex="50">

            </div>
            <div  fxFlex="50">
              <mat-slide-toggle  [formControl]="permissionEmployeeControl" >Pracownicy</mat-slide-toggle>
            </div>
          </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                  <br>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                <mat-slide-toggle [formControl]="permissionPartnerControl" >Partner</mat-slide-toggle>
              </div>
              <div  fxFlex="50">
                <mat-slide-toggle  [formControl]="permissionOfwcaControl" >OFWCA</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                <mat-slide-toggle  [formControl]="permissionPartnerCompetitionControl" > Aktualności marketingowe</mat-slide-toggle>
              </div>
              <div  fxFlex="50">
                <mat-slide-toggle  [formControl]="permissionOfwcaCompetitionControl" >Aktualności marketingowe</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
              </div>
              <div  fxFlex="50">
                <mat-slide-toggle  [formControl]="permissionOfwcaProductControl" >Aktualności produktowe </mat-slide-toggle>
              </div>
            </div>

          </mat-card>
        <mat-card >
          <div fxLayout="row">
            <h4 class="structure-title">Pozostałe</h4>
          </div>
          <div fxLayout="row">
            <p class="structure-description">Dodatkowe parametry po których można ograniczyć odbiorców posta.</p>
          </div>

                <div fxLayout="row" fxLayoutGap="15px">


                  <div  fxFlex="100">
                    <app-dict [label]="'Statusy szkoleń IDD'"
                              [dictType]="'idd_training_status'"
                              [required]="false"
                              [multiple]="true"
                              [formControl]="permissionIddTrainingStatusControl"></app-dict>
                  </div>
                </div>


                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center"  *ngIf="permissionEmployeeControl.value">
                  <div  fxFlex="100">
                    <mat-slide-toggle  [formControl]="permissionDepartmentControl" >Działy </mat-slide-toggle>
                  </div>
                </div>

                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" >
                  <div  fxFlex="100" *ngIf="permissionDepartmentControl.value">
                    <app-dict-departments [formControl]="permissionDepartmentListControl"  [multiple]="true" [required]="permissionDepartmentControl.value" fxFlex="100" label="Działy"></app-dict-departments>
                  </div>
                </div>

                <div fxLayout="row" fxLayoutGap="15px">
                  <div  fxFlex="100">
                      <app-dict-regionals  [formControl]="permissionRegionalControl"  [multiple]="true" fxFlex="100" label="Regionalni"></app-dict-regionals>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center" >
                  <div  fxFlex="50">
                    <app-dict [label]="'Typ umowy'"
                              [dictType]="'contract_type'"
                              [required]="false"
                              [multiple]="true"
                              [onlyKeys]="contractOnlyKeys"
                              [formControl]="permissionContractTypeControl"></app-dict>
                  </div>

                  <div  fxFlex="50">
                    <mat-slide-toggle  [formControl]="permissionContractAndControl" >Typ umowy parametr AND</mat-slide-toggle>
                  </div>
                </div>

                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center" >
                  <div  fxFlex="50">
                    <app-dict  [label]="'Tagi Partnera'"
                               [dictType]="'partner_tags'"
                               [required]="false"
                               [multiple]="true"
                               [formControl]="permissionTagPartnerControl"></app-dict>
                  </div>
                  <div  fxFlex="50" >
                      <mat-slide-toggle    [formControl]="permissionTagPartnerAndControl" >Tagi Partnera parametr AND</mat-slide-toggle>
                  </div>
                </div>

                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" >
                  <div  fxFlex="100">
                    <mat-slide-toggle  [formControl]="permissionRegistrationControl" >Rejestracja </mat-slide-toggle>
                  </div>
                </div>

                <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" >
                  <div  fxFlex="100" *ngIf="permissionRegistrationControl.value">
                    <app-dict-insurance-companies [formControl]="permissionRegistrationListControl"  [multiple]="true" [required]="permissionRegistrationControl.value" fxFlex="100" label="Rejestracje"></app-dict-insurance-companies>
                  </div>
                </div>
              </mat-card>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button [class.spinner]="postAdd" [disabled]="postAdd"  (click)="sendForm(true)" mat-stroked-button color="accent"><mat-icon>publish</mat-icon> <span> Opublikuj</span></button>
    <button [class.spinner]="postAdd" [disabled]="postAdd"  (click)="sendForm(false)" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz jako szkic</span></button>
    <button [class.spinner]="postAdd" [disabled]="postAdd" (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
